import { number } from "@euroland/format-number";
import { i18n } from "@euroland/libs";

import { transitionDecimalDigitsToFormatNumber } from ".";
import { KEY_API_CHANGE_COLOR } from "../constant/common";
import { getFormatSetting, getInstrumentSettings } from "../store/utils";

export const formatNumberBySettings = (value, settings) => {
  if (!settings?.decimalDigits && typeof settings?.decimalDigits !== "number") {
    return number(value);
  }
  const { decimalDigits, thousandsSeparator, decimalSeparator, positiveFormatPattern } = settings;
  const formatNumber = transitionDecimalDigitsToFormatNumber(decimalDigits);

  const options = {
    groupingSeparator: thousandsSeparator,
    decimalSeparator,
  };

  if(!!positiveFormatPattern) {
    options.positiveFormatPattern = positiveFormatPattern;
  }

  return number(value, formatNumber, options);
};

/**
 *
 * @param {number} value
 * @param {number} instrumentId
 * @param {{
 *  decimalDigits: number
 *  thousandsSeparator: string
 *  decimalSeparator: string
 *  positiveFormatPattern: import("../..").IPositiveNumberFormat
 * }} options
 * @returns
 */
export const formatNumberByInstrument = (value, instrumentId, options = {}) => {
  const instrumentSetting = getInstrumentSettings(instrumentId);
  return formatNumberBySettings(value, {
    ...instrumentSetting,
    ...options,
  });
};

// Display value table in share-price tab
export const renderValueTable = (keyApi, dataValue) => {
  if (dataValue.isNullAllData || dataValue[keyApi] === null) return i18n.translate("textNoData");
  // if (keyApi === 'currency') return getCurrencyLabel(dataValue[keyApi]);
  if (["highestVolume", "lowestVolume"].includes(keyApi)) {
    return formatNumberByInstrument(dataValue[keyApi], dataValue.instrumentId, { decimalDigits: 0 });
  }

  if (KEY_API_CHANGE_COLOR.includes(keyApi)) {
    const format = getFormatSetting();
    return `${formatNumberByInstrument(dataValue[keyApi], dataValue.instrumentId, {
      decimalDigits: format.decimalDigits,
      positiveFormatPattern: format.positiveChangeFormat,
    })} %`;
  }
  
  return formatNumberByInstrument(dataValue[keyApi], dataValue.instrumentId);
};
